module.exports = __webpack_public_path__ + "static/img/add1.f2bd95fe.png";